import Image from 'next/image'
import waveDesktop from './assets/address-jumbotron-wave-desktop.svg'
import styles from './components/HeroWave.module.scss'

export const HeroWave = () => (
  <div className={styles['wave-container']}>
    <Image alt="" aria-hidden="true" height={140} layout="responsive" src={waveDesktop} />
  </div>
)
